import { render, staticRenderFns } from "./leave-tile.vue?vue&type=template&id=321a1ae8&scoped=true&"
import script from "./leave-tile.vue?vue&type=script&lang=js&"
export * from "./leave-tile.vue?vue&type=script&lang=js&"
import style0 from "./leave-tile.vue?vue&type=style&index=0&id=321a1ae8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321a1ae8",
  null
  
)

export default component.exports